export default __webpack_public_path__ + "static/media/edit_email.26230f09.png";